<template>
  <div class="contain">
    <img class="gp_title" :src="$img( 'gp.png' )" />

    <div class="wrap">
      <img :src="$img( 'tag.png' )" class="tag-bt">
      <div class="ban">
        <div class="cont">
          <div v-html="data.content"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: ['data']
}
</script>

<style lang="scss" scoped>
.contain {
  position: relative;
  height: 100%;
  background: url('../assets/images/cs_bg.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.gp_title {
  position: absolute;
  top: 20px;
  left: calc( 50% - 155px );
}

.wrap {
  position: relative;
  width: 980px;
  height: 570px;
  background: #fff;
  margin: 0 auto;
  position: relative;
  box-shadow: 0 4px 8px 0 rgba(7,17,27,.1);
  top: 204px;
  padding: 14px 0;
  .tag-bt {
    position: absolute;
    top: -28px;
    left: 0;
  }
}

.ban {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  padding: 0px 50px;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width : 10px;  /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background   : #535353;
  }
  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 10px;
    background   : #ededed;
  }
  img {
    display: inline-block;
    max-width: 100%;
  }
}
</style>